import Input from '@/src/components/Antd/Input/Input';
import React from 'react';
//import { SearchSelect } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const _TableInput = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    isNew,
    onDelete,
    occupiedList,
    disabled = false,
  } = props;

  const iniV = React.useRef(value);
  const [v, setV] = React.useState(value || '');
  const [focus, setFocus] = React.useState(false);
  // const [hasError, setHasError] = React.useState(false);
  const [touched, setTouched] = React.useState(!isNew);

  React.useEffect(() => {
    if (isNew && v != '') {
      setTouched(true);
    }
  }, [v]);

  React.useEffect(() => {
    if (v != value) {
      setV(value);
    }
  }, [value]);

  const handleOnFocus = () => {
    // console.log('onFucs');
    setFocus(true);
  };

  const _hasError = React.useMemo(() => {
    if (!v) {
      return true;
    }
    if (occupiedList.includes(v)) {
      return true;
    }
    return false;
  }, [v]);

  const _displayError = React.useMemo(() => {
    if (!v && touched) {
      return true;
    }
    if (occupiedList.includes(v)) {
      return true;
    }
    return false;
  }, [v]);

  const help = () => {
    if (!v) {
      return getI18n('storeTagManager.fileTag.pleasefilltagtitle');
    }
    if (occupiedList.includes(v)) {
      return getI18n('storeTagManager.fileTag.thistitlehasbeenoccupied');
    }
    return '';
  };

  const handleOnBlur = () => {
    if (_hasError) {
      if (isNew) {
        onDelete();
      } else {
        setV(iniV.current);
        setFocus(false);
      }
    } else {
      onChange(v);
      setFocus(false);
    }
  };

  const shouldEdit = focus || _displayError || isNew;
  return (
    <div className={`${css.container}`} onClick={handleOnFocus}>
      {shouldEdit ? (
        <div className={css.edittingContainer}>
          <Input
            error={_displayError}
            help={help()}
            value={v}
            onChange={setV}
            autoFocus={true}
            onBlur={() => {
              handleOnBlur();
            }}
            size='large'
            disabled={disabled}
          />
        </div>
      ) : (
        <NoWrapContainer>
          <GlobalTooltip title={value}>{value}</GlobalTooltip>
        </NoWrapContainer>
      )}
    </div>
  );
};

export default _TableInput;
